export default __webpack_public_path__ + "static/media/liberum-1.61e0ad39.png";